export { LastWinnersCarousel } from './LastWinnersCarousel';
